<template>
    <div class="abnormal-ammeter">
        <div class="totle-content">
            <div class="select-search">
                <div class="select-group">

                </div>
                <div class="button-group">
                    <el-select v-model="status" filterable placeholder="请选择状态" @change="skip=0;limit=20;cur_page=1;AbnormalAmmeter()">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>

                    <!--<el-button type="primary" icon="el-icon-search" @click="skip=0;limit=20;cur_page=1;AbnormalAmmeter()">搜索</el-button>-->
                    <el-button type="success" icon="el-icon-tickets" @click="downloadMater">导出</el-button>
                </div>
            </div>

            <div class="table-content">
                <el-table class="table-head" :data="ammeterData" border>
                    <el-table-column align="center" type="index" min-width="50"></el-table-column>
                    <!--<el-table-column prop="housecode" label="房源编号" width="180"></el-table-column>-->
                    <el-table-column align="center" prop="cityvillage" label="城市苑区" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="address" label="详细地址" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="room" label="房间名称" min-width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="abdevice" label="设备编码" min-width="150"></el-table-column>
                    <el-table-column align="center" prop="state" label="状态"></el-table-column>
                    <el-table-column align="center" prop="staydate" label="操作" min-width="50">
                        <template slot-scope="scope">
                            <el-button @click="toHouse(scope.$index, ammeterData)" type="text" size="small">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination-part">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="cur_page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="20"
                        layout="total,sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
            <!--弹框-->
            <el-dialog title="异常详情" width="6rem" :visible.sync="dialogFormVisible">
                <el-form :model="form">
                    <el-form-item label="地址:" :label-width="formLabelWidth">
                        <span>{{form.addr}}</span>
                    </el-form-item>
                    <el-form-item label="异常:" :label-width="formLabelWidth">
                        <span>{{form.abnormal}}</span>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">已解决</el-button>
                    <el-button type="primary" @click="">建立工单</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
    import store from "../store";
    var FileSaver = require('file-saver');

    export default {
        name: "AbnormalAmmeter",
        data() {
            return {
                ammeterData: [],
                total: 0,
                skip: 0,
                limit: 20,
                status:'',
                options: [{
                    value: '0',
                    label: '全部'
                }, {
                    value: '1',
                    label: '异常'
                }, {
                    value: '2',
                    label: '离线'
                }],

                dialogFormVisible: false,
                formLabelWidth: '80px',
                form: {
                    addr: '',
                    abnormal: '',
                },
                cur_page:1,


            }
        },
        mounted() {
            this.AbnormalAmmeter();
        },
        methods: {
            AbnormalAmmeter() {
                var status;
                if(this.status==''){
                    status='0';
                }else{
                    status=this.status;
                }
                this.$http.get(`${store.state.url}zone/abnormalammeters/`+status+`/` + this.skip + `/` + this.limit + `?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            let ammeterData = [];
                            if(res.Data!=null) {
                                for (let i in res.Data) {
                                    let state;
                                    if (res.Data[i].Status == 1) {
                                        state = '异常'
                                    } else if (res.Data[i].Status == 2) {
                                        state = '离线'
                                    }
                                    ammeterData[i] = {
                                        cityvillage: res.Data[i].CityArea,
                                        address: res.Data[i].Addr,
                                        room: res.Data[i].Room,
                                        abdevice: res.Data[i].Pcode,
                                        state: state,
                                        suiteid: res.Data[i].Suiteid,
                                    }
                                }
                            }
                            this.ammeterData = ammeterData;
                            this.total = res.Expand;
                        } else {
                            this.ammeterData = [];
                            this.total = 0;
                            this.$message(res.Message);
                        }
                    })
            },

            //显示弹框
            Detail() {
                this.dialogFormVisible = true;
            },

            //分页
            handleSizeChange(val) {
                this.limit = val;
                this.AbnormalAmmeter();
            },
            handleCurrentChange(val) {
                this.skip = (val - 1) * this.limit;
                this.AbnormalAmmeter();
            },

            //过滤
            filterHandler(value, row, column) {
                const property = column['property'];
                return row[property] === value;
            },

            //导出1000条数据
            downloadData(){
                return new Promise((resolve, reject) => {
                    var status;
                    if(this.status==''){
                        status='0';
                    }else{
                        status=this.status;
                    }
                    var ammeterData = [];
                    this.$http.get(`${store.state.url}zone/abnormalammeters/`+status+`/0/1000?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                if(res.Data!=null) {
                                    for (let i in res.Data) {
                                        let state;
                                        if (res.Data[i].Status == 1) {
                                            state = '异常'
                                        } else if (res.Data[i].Status == 2) {
                                            state = '离线'
                                        }
                                        ammeterData[i] = {
                                            cityvillage: res.Data[i].CityArea,
                                            address: res.Data[i].Addr,
                                            room: res.Data[i].Room,
                                            abdevice: res.Data[i].Pcode,
                                            state: state,
                                        }
                                    }
                                    resolve(ammeterData);
                                }
                            }
                        });
                })
            },

            //导出excel
            downloadMater() {
                this.downloadData().then((ammeterData) => {
                    const defaultCellStyle = {
                        font: {name: "Verdana", sz: 11, color: "FF00FF88"},
                        fill: {fgColor: {rgb: "FFFFAA00"}}
                    };
                    const wopts = {
                        bookType: 'xlsx',
                        bookSST: false,
                        type: 'binary',
                        defaultCellStyle: defaultCellStyle,
                        showGridLines: false
                    };
                    const wb = {SheetNames: ['Sheet1'], Sheets: {}, Props: {}};

                    let Data = [];
                    for (let i in ammeterData) {
                        Data[i] = {
                            城市苑区: ammeterData[i].cityvillage,
                            详细地址: ammeterData[i].address,
                            设备编码: ammeterData[i].abdevice,
                            状态: ammeterData[i].state,
                        };
                    }
                    let data = Data;
                    wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

                    //创建二进制对象写入转换好的字节流
                    let tmpDown = new Blob([this.s2ab(XLSX.write(wb, wopts))], {type: "application/octet-stream"})
                    FileSaver.saveAs(tmpDown, "离线和异常设备报表.xls");
                });
            },
            //字符串转字符流
            s2ab(s) {
                if (typeof ArrayBuffer !== 'undefined') {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                } else {
                    var buf = new Array(s.length);
                    for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
            },

            toHouse(index, row) {
                let sid = row[index].suiteid,
                    tableInfo = {};
                window.localStorage.sid = sid;
                tableInfo.table = 0;
                tableInfo.index = '1';
                store.commit('assignAbnormalPreTableTab', tableInfo);
                this.$router.push('./house');
            }
        },
    }
</script>

<style scoped>
    .el-select{
        width:2rem;
    }

</style>
